/** 相邻消息超过该间隔则显示时间 */
export const MESSAGE_TIME_GAP_MS = 30 * 60 * 1000;
export function toMessageTimestamp(value) {
    if (value == null)
        return 0;
    if (typeof value === 'number') {
        return value < 1e12 ? value * 1000 : value;
    }
    const parsed = new Date(String(value).replace(/-/g, '/')).getTime();
    return Number.isNaN(parsed) ? 0 : parsed;
}
export function shouldShowMessageTime(current, previous, gapMs = MESSAGE_TIME_GAP_MS) {
    const currentTs = toMessageTimestamp(current);
    if (!currentTs)
        return false;
    if (previous == null)
        return true;
    const prevTs = toMessageTimestamp(previous);
    if (!prevTs)
        return true;
    return currentTs - prevTs >= gapMs;
}
/** 微信风格会话时间 */
export function formatChatMessageTime(value, now = Date.now()) {
    const ts = toMessageTimestamp(value);
    if (!ts)
        return '';
    const date = new Date(ts);
    const pad = (n) => String(n).padStart(2, '0');
    const clock = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
    const startOfDay = (d) => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
    const todayStart = startOfDay(new Date(now));
    const messageDayStart = startOfDay(date);
    const dayDiff = Math.floor((todayStart - messageDayStart) / 86400000);
    if (dayDiff === 0)
        return clock;
    if (dayDiff === 1)
        return `昨天 ${clock}`;
    if (date.getFullYear() === new Date(now).getFullYear()) {
        return `${date.getMonth() + 1}月${date.getDate()}日 ${clock}`;
    }
    return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日 ${clock}`;
}
